export interface Theme {
  name: string;
  properties: any;
}

// Corvus TID - Tema por defecto (Dark Tech)
export const defaultTheme: Theme = {
  name: 'defaultTheme',
  properties: {
    '--first-color': '#0D6EFD',
    '--first-color-alt': '#0A58CA',
    '--first-color-lighter': '#74B3FF',
    '--first-color-lightest': '#DBEAFE',
    '--body-color': '#080C12',
    '--body-color-alt': '#121922',
    '--container-color': '#161F2B',
    '--card-color': '#F8FBFF',
    '--title-color': '#F5F8FD',
    '--text-color': '#C7D2E0',
    '--text-color-light': '#8F9DB0',
    '--text-color-dark': '#0F1724',
    '--border-color': '#2B3748',
    '--scroll-bar-color': '#223044',
    '--scroll-thumb-color': '#0D6EFD',
    '--shadow-color': 'rgba(5, 12, 23, 0.45)',
    '--shadow-color-strong': 'rgba(2, 8, 18, 0.72)',
    '--glow-color': 'rgba(13, 110, 253, 0.24)',
  },
};

// Corvus TID - Tema claro
export const light: Theme = {
  name: 'light',
  properties: {
    '--first-color': '#0D6EFD',
    '--first-color-alt': '#0A58CA',
    '--first-color-lighter': '#74B3FF',
    '--first-color-lightest': '#DBEAFE',
    '--body-color': '#F4F7FB',
    '--body-color-alt': '#FFFFFF',
    '--container-color': '#FFFFFF',
    '--card-color': '#FFFFFF',
    '--title-color': '#0F1724',
    '--text-color': '#253346',
    '--text-color-light': '#62748D',
    '--text-color-dark': '#0F1724',
    '--border-color': '#D7E2EF',
    '--scroll-bar-color': '#D7E2EF',
    '--scroll-thumb-color': '#0D6EFD',
    '--shadow-color': 'rgba(0, 0, 0, 0.1)',
    '--shadow-color-strong': 'rgba(0, 0, 0, 0.2)',
    '--glow-color': 'rgba(13, 110, 253, 0.2)',
  },
};

// Corvus TID - Tema azul profundo (Purple convertido a Blue)
export const purple: Theme = {
  name: 'blue',
  properties: {
    '--first-color': '#1E40AF',
    '--first-color-alt': '#1E3A8A',
    '--first-color-lighter': '#3B82F6',
    '--first-color-lightest': '#BFDBFE',
    '--body-color': '#0F172A',
    '--body-color-alt': '#1E293B',
    '--glow-color': 'rgba(30, 64, 175, 0.4)',
  },
};

// Variante verde tecnológico (opcional)
export const green: Theme = {
  name: 'green',
  properties: {
    '--first-color': '#10B981',
    '--first-color-alt': '#059669',
    '--first-color-lighter': '#34D399',
    '--first-color-lightest': '#D1FAE5',
    '--glow-color': 'rgba(16, 185, 129, 0.3)',
  },
};

// Variante cyan tecnológico (pink convertido)
export const pink: Theme = {
  name: 'cyan',
  properties: {
    '--first-color': '#06B6D4',
    '--first-color-alt': '#0891B2',
    '--first-color-lighter': '#22D3EE',
    '--first-color-lightest': '#CFFAFE',
    '--glow-color': 'rgba(6, 182, 212, 0.3)',
  },
};

// Corvus TID - Tema oscuro
export const dark: Theme = {
  name: 'dark',
  properties: {
    '--first-color': '#2563EB',
    '--first-color-alt': '#1E40AF',
    '--first-color-lighter': '#60A5FA',
    '--first-color-lightest': '#DBEAFE',
    '--body-color': '#000000',
    '--body-color-alt': '#0A0E27',
    '--container-color': '#0A0E27',
    '--card-color': '#1E293B',
    '--title-color': '#F1F5F9',
    '--text-color': '#E2E8F0',
    '--text-color-light': '#94A3B8',
    '--text-color-dark': '#0A0E27',
    '--border-color': '#1E293B',
    '--scroll-bar-color': '#1E293B',
    '--scroll-thumb-color': '#2563EB',
    '--shadow-color': 'rgba(0, 0, 0, 0.5)',
    '--shadow-color-strong': 'rgba(0, 0, 0, 0.8)',
    '--glow-color': 'rgba(37, 99, 235, 0.4)',
  },
};

// Corvus TID - Tema Monocromático (Blanco y Negro)
export const monochrome: Theme = {
  name: 'monochrome',
  properties: {
    '--first-color': '#000000',
    '--first-color-alt': '#1A1A1A',
    '--first-color-lighter': '#333333',
    '--first-color-lightest': '#666666',
    '--body-color': '#FFFFFF',
    '--body-color-alt': '#F5F5F5',
    '--container-color': '#F5F5F5',
    '--card-color': '#FAFAFA',
    '--title-color': '#000000',
    '--text-color': '#1A1A1A',
    '--text-color-light': '#666666',
    '--text-color-dark': '#000000',
    '--border-color': '#E0E0E0',
    '--scroll-bar-color': '#E0E0E0',
    '--scroll-thumb-color': '#333333',
    '--shadow-color': 'rgba(0, 0, 0, 0.1)',
    '--shadow-color-strong': 'rgba(0, 0, 0, 0.2)',
    '--glow-color': 'rgba(0, 0, 0, 0.15)',
  },
};
